import { BrandAndMarketPermissionResponse, CabinTypeResponse, FareTypeResponse, JourneyTypeResponse, RelevanceResponse } from '../../../integrated-client';

export interface IBusinessData {
  brandAndMarkets?: Array<BrandAndMarketPermissionResponse>;
  cabinTypes?: Array<CabinTypeResponse>;
  fareTypes?: Array<FareTypeResponse>;
  relevances?: Array<RelevanceResponse>;
  journeyTypes?: Array<JourneyTypeResponse>;
}

export class BusinessData implements IBusinessData {
  brandAndMarkets: Array<BrandAndMarketPermissionResponse>;
  cabinTypes: Array<CabinTypeResponse>;
  fareTypes: Array<FareTypeResponse>;
  relevances: Array<RelevanceResponse>;
  journeyTypes?: JourneyTypeResponse[] | undefined;

  constructor() {
    this.brandAndMarkets = [];
    this.cabinTypes = [];
    this.fareTypes = [];
    this.relevances = [];
    this.journeyTypes = [];
  }
}
